export default function SectionApp() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 p-6 md:p-10 rounded-2xl bg-background-50 border border-background-200/60">
          <div className="shrink-0 w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Mobile%20phone%20displaying%20cinematic%20movie%20streaming%20interface%20with%20dark%20theme%2C%20film%20poster%20thumbnails%2C%20elegant%20UI%20design%2C%20warm%20amber%20accents%2C%20premium%20app%20aesthetic%2C%20modern%20minimal%20layout%2C%20no%20text&width=400&height=400&seq=app-mitao-2026&orientation=squarish"
              alt="密桃视频 - 移动端观影体验"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2">随时随地 · 畅快观影</h2>
            <p className="text-sm text-foreground-500 leading-relaxed mb-4">
              密桃视频移动端已全面适配，无需下载安装，手机浏览器直接访问即可享受与桌面端一致的流畅观影体验。91在线视频播放器针对触屏操作做了深度优化，手势控制音量亮度，追剧看片更顺手。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center md:justify-start">
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors text-center cursor-pointer"
              >
                <i className="ri-global-line mr-2"></i>立即访问网页版
              </a>
              <span className="text-xs text-foreground-400 whitespace-nowrap">无需下载 · 浏览器即开即看</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}